import React, { Component } from "react";
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

export default class Footer extends Component {
	
	render () {
		
		let post 		= this.props.post;
		let showfooter 	= this.props.showfooter;
				
		if (showfooter == true) {
						   
		    return (
			    
			    <>
				    <div className="c-footer">
				    	<div className="c-page__block c-page__block--border-top c-page__block--load-effect">
				    		<div className="l-grid">
				    			<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-8-12">
				    				<h3 className="c-footer__logo">
				    					<Link to={{ pathname: '/' }} className="c-footer__logo__inner" dangerouslySetInnerHTML={ {__html: '<svg viewBox="0 0 100 48"><path d="m40.76 29.4h-4.7c-1.59 0-2.58-0.66-2.58-1.99v-27.41h-7.35v29.46 0.08c0.02 4 3.28 7.23 7.28 7.21h7.28v1.92c0 1.46-0.4 1.99-2.05 1.99h-5.23v7.34h7.35c4-0.06 7.22-3.29 7.28-7.28v-40.72h-7.28v29.4zm-25.63-29.4h-7.54c-4 0.06-7.22 3.29-7.28 7.28v6.02c0 3.51 2.51 4.9 4.9 6.09 2.45 1.19 4.63 2.45 7.08 3.84 1.06 0.6 2.58 1.26 2.58 2.65v1.53c0 1.46-0.4 1.99-2.05 1.99h-3.11c-1.46 0-1.99-0.46-1.99-2.12v-1.92h-7.35v4.03c0.04 3.99 3.23 7.23 7.22 7.35h7.35c4-0.06 7.22-3.28 7.28-7.28v-6.29c0-3.51-2.52-4.9-4.9-6.09-2.45-1.19-4.63-2.45-7.08-3.84-1.06-0.6-2.58-1.26-2.58-2.65v-1.25c0-1.46 0.4-1.99 2.05-1.99h3.31c1.46 0 1.99 0.46 1.99 2.12v1.92h7.35v-4.04c-0.05-3.99-3.24-7.23-7.23-7.35zm51.46 0h-14.64v36.74h7.35v-29.4h4.63c1.32 0 2.58 0.53 2.58 1.99v27.41h7.36v-29.46-0.05c-0.02-4-3.28-7.24-7.28-7.23zm33.1 22.47h-7.56v6.92h-4.42c-1.59 0-2.58-0.66-2.58-1.99v-18.07c0-1.46 0.4-1.99 2.05-1.99h4.95v6.87h7.56v-14.21h-14.63c-4 0.06-7.22 3.29-7.28 7.28v22.18c-0.02 4 3.2 7.26 7.21 7.28h0.08 14.63l-0.01-14.27z"/></svg>'}}></Link>
				    				</h3>
				    			</div>
				    			<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12">
				    				<div className="scope-text scope-text--footer">
				    					{post.ftr_office.map((office,i) =>
											{
												return (
													<>
								    					{office.ftr_address &&
									    					<h4 dangerouslySetInnerHTML={ {__html: office.ftr_address}}></h4>
								    					}
								    					{office.ftr_direction_url &&
									    					<p dangerouslySetInnerHTML={ {__html: '<a href="' + office.ftr_direction_url + '">Get Directions</a>'}}></p>
								    					}
								    					{office.ftr_phone_number && office.ftr_phone_number_url &&
									    					<>
									    						<h4 dangerouslySetInnerHTML={ {__html: 'Phone'}}></h4>
									    						<p dangerouslySetInnerHTML={ {__html: '<a class="no-underline" href="tel:' + office.ftr_phone_number_url + '">' + office.ftr_phone_number + '</a>'}}></p>
									    					</>
								    					}
								    				</>
							    				)
							    			}
										)}
				    					{post.ftr_email &&
					    					<>
					    						<h4 dangerouslySetInnerHTML={ {__html: 'Email'}}></h4>
												<p dangerouslySetInnerHTML={ {__html: '<a class="no-underline" href="mailto:' + post.ftr_email + '">' + post.ftr_email + '</a>'}}></p>
					    					</>
				    					}
				    					{post.ftr_instagram_url &&
					    					<>
				    							<h4 dangerouslySetInnerHTML={ {__html: 'Social'}}></h4>
												<p dangerouslySetInnerHTML={ {__html: '<a class="no-underline" href="' + post.ftr_instagram_url + '">Instagram</a>'}}></p>
											</>
				    					}
				    					{post.rego_heading && post.rego_text &&
					    					<>
				    							<h4 dangerouslySetInnerHTML={ {__html: post.rego_heading}}></h4>
												<p dangerouslySetInnerHTML={ {__html: post.rego_text}}></p>
											</>
				    					}
				    				</div>
				    				
				    			</div>
				    		</div>
					    </div>
					    <div className="c-page__block c-page__block--no-space c-page__block--border-bottom c-page__block--load-effect">
					    	<div className="l-grid">
					    		<div className="l-grid__col">
							    	<h5 className="c-footer__insti-logo">
								    	<a href="https://www.architecture.com.au/" target="_blank" className="c-footer__insti-logo__inner" dangerouslySetInnerHTML={ {__html: ''}}></a>
									</h5>
							    </div>
							</div>
						</div>
					</div>
					<div className="c-page__block c-page__block--no-space c-page__block--border-bottom c-page__block--load-effect u-m-hide">
				    	<div className="l-grid">
				    		<div className="l-grid__col">
				    			<h4 className="c-footer__tagline c-paragraph" dangerouslySetInnerHTML={ {__html: 'Architecture and Interiors'}}></h4>
				    		</div>
				    	</div>
				    </div>
				    <div className="c-page__block c-page__block--no-space c-page__block--load-effect">
				    	<div className="l-grid l-grid--m-middle">
				    		<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-8-12 u-m-show">
				    			{post.ftr_privacy_url &&
				    				<p className="c-paragraph c-paragraph--faded c-paragraph--very-small">Copyright Sync Architecture<span dangerouslySetInnerHTML={ {__html:'&nbsp;&nbsp;&nbsp;'}}></span><Link to={{ pathname: post.ftr_privacy_url }} dangerouslySetInnerHTML={ {__html: 'Privacy Policy'}}></Link></p>
				    			}
				    			{!post.ftr_privacy_url &&
					    			<p className="c-paragraph c-paragraph--faded c-paragraph--very-small">Copyright Sync Architecture</p>
				    			}
				    		</div>
				    		<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-8-12 u-m-hide">
				    			{post.ftr_privacy_url &&
				    				<p className="c-paragraph c-paragraph--faded c-paragraph--very-small">Copyright Sync Architecture<br /><Link to={{ pathname: post.ftr_privacy_url }} dangerouslySetInnerHTML={ {__html: 'Privacy Policy'}}></Link></p>
				    			}
				    			{!post.ftr_privacy_url &&
				    				<p className="c-paragraph c-paragraph--faded c-paragraph--very-small">Copyright Sync Architecture</p>
				    			}
				    		</div>
				    		<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-4-12 u-m-show">
				    			<h4 className="c-footer__tagline c-paragraph" dangerouslySetInnerHTML={ {__html: 'Architecture and Interiors'}}></h4>
				    		</div>
				    	</div>
				    </div>
					
				</>
			)
			
		} else {
			
			return null;
					
		}
		
	}
			
}
